/* NativeDSD: digital downloads can be added to the cart once per version (quality + channels).
   - The Add to cart button turns grey and says "Already in the cart" while the selected version is in the cart; a click
     does nothing, and a submit is blocked too (Enter key, second tab).
   - A note under the button when the customer bought the selected version before, or another version of the album
     (data from snippets/ndsd-cart-guard.liquid; may be empty: only logged in customers with Shopify orders).
   Default product template only: the snippet is not rendered for physical products, memberships or gift cards. */
(() => {
  if (window.ndsdCartGuard) return;
  window.ndsdCartGuard = true;

  let inCart = new Set();
  let scheduled = false;

  const variantOf = (form) => {
    const input = form.querySelector('.product-variant-id');
    return input ? String(input.value) : '';
  };
  const guarded = (form) => form.closest('.product-form')?.querySelector('.ndsd-owned-note');

  const apply = () => {
    scheduled = false;
    document.querySelectorAll('form[is="product-form"]').forEach((form) => {
      const note = guarded(form);
      if (!note) return; // not a digital download page
      const id = variantOf(form);
      // the main button, and the one in the sticky bar (it belongs to the same form through its form attribute)
      const buttons = [
        form.querySelector('.product-form__submit[name="add"]'),
        ...(form.id ? document.querySelectorAll(`.product-form__submit[form="${form.id}"]`) : []),
      ];
      buttons.forEach((button) => {
        if (!button || button.disabled) return;
        const text = button.querySelector('.btn__text');
        const has = inCart.has(id);
        if (has && !button.classList.contains('ndsd-in-cart')) {
          button.dataset.ndsdLabel = text ? text.textContent : '';
          if (text) text.textContent = 'Already in the cart';
          button.classList.add('ndsd-in-cart');
          button.setAttribute('aria-disabled', 'true');
        } else if (!has && button.classList.contains('ndsd-in-cart')) {
          if (text && button.dataset.ndsdLabel) text.textContent = button.dataset.ndsdLabel;
          button.classList.remove('ndsd-in-cart');
          button.removeAttribute('aria-disabled');
        }
      });
      showOwned(note, id);
    });
  };

  const showOwned = (note, id) => {
    let owned = [];
    try {
      owned = JSON.parse(note.dataset.owned || '[]');
    } catch (e) {}
    if (!owned.length) {
      if (!note.hidden) note.hidden = true;
      return;
    }
    const same = owned.find((o) => String(o.variant) === id);
    const versions = [...new Set(owned.map((o) => o.title).filter(Boolean))].join(', ');
    const text = same
      ? `You already bought this version (${same.title}) on ${same.date}, order ${same.order}. You can download it again from your account.`
      : `You already own this album${versions ? ` in ${versions}` : ''}.`;
    const link = same ? '' : ` <a href="${note.dataset.requestUrl}">Request an additional resolution</a>`;
    const html = `${text}${link}`;
    if (note.dataset.rendered !== html) {
      note.dataset.rendered = html;
      note.innerHTML = '';
      const p = document.createElement('p');
      p.className = 'ndsd-owned-note__text';
      p.append(text);
      if (link) {
        p.append(' ');
        const a = document.createElement('a');
        a.href = note.dataset.requestUrl;
        a.textContent = 'Request an additional resolution';
        p.append(a);
      }
      note.append(p);
    }
    note.hidden = false;
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(apply);
  };

  const refreshCart = async () => {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      inCart = new Set(cart.items.filter((i) => !i.requires_shipping).map((i) => String(i.variant_id)));
    } catch (e) {}
    apply();
  };

  // block the add itself, not only the look of the button
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!form.matches || !form.matches('form[is="product-form"]')) return;
      if (!guarded(form)) return;
      if (inCart.has(variantOf(form))) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.product-form__submit.ndsd-in-cart');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener('cart:updated', refreshCart);
  window.addEventListener('pageshow', refreshCart);
  if (window.FoxTheme && FoxTheme.pubsub) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, refreshCart);
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, schedule);
  }
  // the section is re-rendered when another quality/channels is picked: look again whenever the form changes
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  // a successful add changes the cart without an event we can rely on: look again shortly after a submit
  document.addEventListener('submit', () => {
    setTimeout(refreshCart, 1200);
    setTimeout(refreshCart, 3500);
  });

  refreshCart();
})();
